import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onAddPatient }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mb-6">
        <Icon name="Users" size={40} className="text-primary" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-2">
        Nenhum paciente cadastrado
      </h3>
      <p className="text-sm text-muted-foreground text-center max-w-md mb-6">
        Comece adicionando seu primeiro paciente para gerenciar consultas, histórico de sessões e informações de contato.
      </p>
      <Button
        variant="default"
        onClick={onAddPatient}
        iconName="Plus"
        iconPosition="left"
      >
        Adicionar Primeiro Paciente
      </Button>
    </div>
  );
};

export default EmptyState;